<template>
    <div class="lm-down-scaler">
        <div class="lm-scaler-inner" :class="[{loaded}]" :style="borderStyles">
            <div ref="layout" class="lm-layout" :style="layoutStyle">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "TxProductViewportScaler",
        props: {
            dimm: {
                type: [Object, Boolean],
            },
            layout: {
                type: String,
            }
        },
        watch: {
            borderStyles: {
                handler: function (newValue, oldValue) {
                    this.$nextTick(() => {
                        this.centerContainer();
                    })
                },
                deep: true,
            },
            layout: {
                handler: function (newValue, oldValue) {
                    this.$nextTick(() => {
                        this.centerContainer();
                    })
                },
            }
        },
        data() {
            return {
                multiplier: 1,
                sizes: [1920, 1080],
                marginLeft: 0,
                scale: 1,
                scaleY: 1,
                scaleX: 1,
                loaded: false,
            }
        },
        mounted() {
            this.$nextTick(() => {
                this._timeout = setTimeout(() => {
                    this.loaded = true
                }, 1500)
                this._interval = setInterval(() => {
                    this.centerContainer();
                }, 500)
            })
        },
        beforeDestroy() {
            clearInterval(this._interval);
            clearTimeout(this._timeout)
        },
        computed: {
            borderStyles() {
                let layout = this.layoutSize();
                let borderStyles = {};
                if (this.dimm) {
                    this.scaleX = this.dimm.maxWidth / layout.width
                    this.scaleY = this.dimm.maxHeight / layout.height

                    // this.scale = this.layout === 'vertical' ? this.scaleX : this.scaleY
                    this.scale = Math.min(this.scaleX, this.scaleY);
                    this.$emit('scale', this.scale);
                    borderStyles = {
                        ...layout,
                    }
                    if (this.$root.env !== 'renderer') {
                        borderStyles = {
                            ...borderStyles,
                            ...this.scalerStyles()
                        }
                        borderStyles.transformOrigin = `top left`;
                        borderStyles.transform = `scale(${this.scale})`;
                    } else {
                        // borderStyles.transformOrigin = `top left`;
                        // borderStyles.transform = `scale(1)`;
                    }
                }

                return borderStyles
            },
            containerStyles() {
                return {
                    maxHeight: `${this.dimm.maxHeight * this.scale + 50}px`
                }
            },
            layoutStyle() {
                let [axisX, axisY] = this.sizes;
                let multiplier = this.multiplier;
                if (this.layout === 'vertical') {
                    return {
                        width: `${axisY * multiplier}px`,
                        // height: `${axisX * multiplier}px`,
                    }
                } else {
                    return {
                        width: `${axisX * multiplier}px`,
                        // height: `${axisY * multiplier}px`,
                    }
                }
            }
        },
        methods: {
            centerContainer() {
                if (this.layout === 'vertical') {
                    this.marginLeft = (this.$el?.clientWidth - this.$refs?.layout?.clientWidth * this.scale) / 2;
                } else {
                    this.marginLeft = 0;
                }
            },
            layoutSize() {
                let [axisX, axisY] = this.sizes;
                let multiplier = this.multiplier;
                if (this.layout === 'vertical') {
                    return {
                        width: axisY * multiplier,
                        height: axisX * multiplier,
                    }
                } else {
                    return {
                        width: axisX * multiplier,
                        height: axisY * multiplier,
                    }
                }
            },
            scalerStyles() {
                if (!this.marginLeft) return {}
                return {
                    marginLeft: `${this.marginLeft}px`
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .lm-down-scaler,
    .lm-scaler-inner {
        width: 100%;
        height: 100%;
    }

    .lm-down-scaler {

    }

    .lm-layout {
        transition: all 0.2s cubic-bezier(0.25, 0.8, 0.5, 1);
    }

    .lm-scaler-inner {
        will-change: transform;

        &.loaded {
            transition: all 0.2s cubic-bezier(0.25, 0.8, 0.5, 1);
        }
    }
</style>